import { Shipping } from '../../TabbedNavigation/Shipping'

interface ShippingCalculatorProps {
  isPreSale?: boolean
  preSaleText?: string
}

export function ShippingCalculator({
  isPreSale,
  preSaleText = '',
}: ShippingCalculatorProps) {
  return (
    <section className="mt-lg pb-6">
      <ul className="flex items-center gap-lg">
        <li>
          <span className="desktop-body-semibold-text2">
            Calcule frete e retirada
          </span>
        </li>
      </ul>

      {isPreSale && (
        <div className="mt-[20px] mb-4 w-full px-3 py-2 bg-mediumGray">
          <span className="text-xs font-regular text-restructure-primary">
            <strong className="font-bold">Atenção:</strong> {preSaleText}
          </span>
        </div>
      )}

      <div className="scroll-bar-gray mt-lg overflow-y-auto">
        <Shipping />
      </div>
    </section>
  )
}
